export const selectCaseload = (state) => state.coachInsights.caseload;
export const selectCoachSearch = (state) => state.coachInsights.search;
export const selectCustomerId = (state) => state.coachInsights.customerId;
export const selectOverview = (state) => state.coachInsights.customer.overview;
export const selectActivity = (state) => state.coachInsights.customer.activity;
export const selectNightState = (state) => state.coachInsights.customer.night;
export const selectTrends = (state) => state.coachInsights.customer.trends;
export const selectCoachProfile = (state) => state.coachInsights.customer.profile;
export const selectNotes = (state) => state.coachInsights.customer.notes;
export const selectInterventions = (state) => state.coachInsights.customer.interventions;
export const selectSupportHistory = (state) => state.coachInsights.customer.support;
export const selectIntake = (state) => state.coachInsights.customer.intake;
export const selectCheckIns = (state) => state.coachInsights.customer.checkIns;

export const selectCachedNight = (state, customerId, date) =>
  state.coachInsights.nightsByCustomer[customerId]?.[date] ?? null;

export const selectCachedWeek = (state, customerId, date) =>
  state.coachInsights.weeks[customerId]?.[date] ?? null;

// The week comparison for the night on screen.
export const selectComparisonWeek = (state) => {
  const { customerId, customer } = state.coachInsights;
  return selectCachedWeek(state, customerId, customer.night.date);
};

// The night on screen: cached data for the selected date, if any.
export const selectCurrentNight = (state) => {
  const { customerId, customer } = state.coachInsights;
  const date = customer.night.date;
  return date ? (state.coachInsights.nightsByCustomer[customerId]?.[date]?.data ?? null) : null;
};
